module.exports = __webpack_public_path__ + "img/03_slides.162817a9.png";